import React from "react";
import { motion } from "framer-motion";
import { FaHamburger } from "react-icons/fa";
import styles from "./Navbar.module.css";

const Navbar = () => {
  return (
    <nav className={`navbar navbar-expand-lg navbar-light transparent my-1`}>
      <div className="container">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
          <ul className="navbar-nav mb-2 mb-lg-0 ms-auto">
            <motion.li
              className="nav-item"
              style={{
                paddingLeft: "1rem",
                paddingRight: "1rem",
              }}
            >
              <a className="nav-link active" href="#info-container">
                About 👩‍💻
              </a>
            </motion.li>
            <motion.li
              className="nav-item"
              style={{
                paddingLeft: "1rem",
                paddingRight: "1rem",
              }}
            >
              <a className="nav-link" href="#projects-container">
                Portfolio 📍
              </a>
            </motion.li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
